import { ROUTES } from '@platform/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: ROUTES.settingsWorkspace,
      params: { workspaceId: params.workspaceId },
    })
  },
})
